import React from 'react';

const statusArray = [
    {
        status: "-9",
        text: "خطای اعتبار سنجی"
    },
    {
        status: "-10",
        text: "ای پی یا مرچنت كد پذیرنده صحیح نیست"
    },
    {
        status: "-11",
        text: "مرچنت کد فعال نیست"
    },
    {
        status: "-12",
        text: "تلاش بیش از دفعات مجاز در یک بازه زمانی کوتاه"
    },
    {
        status: "-15",
        text: "درگاه پرداخت به حالت تعلیق در آمده است"
    },
    {
        status: "-16",
        text: "سطح تایید پذیرنده پایین تر از سطح نقره ای است"
    },
    {
        status: "-17",
        text: "محدودیت پذیرنده در سطح آبی"
    },
    {
        status: "100",
        text: "عملیات موفق"
    },
    {
        status: "-30",
        text: "پذیرنده اجازه دسترسی به سرویس تسویه اشتراکی شناور را ندارد"
    },
    {
        status: "-31",
        text: "مقادیر وارد شده برای تسهیم درست نیست"
    },
    {
        status: "-32",
        text: "مبلغ وارد شده از مبلغ کل تراکنش بیشتر است"
    },
    {
        status: "-33",
        text: "درصدهای وارد شده صحیح نیست"
    },
    {
        status: "-34",
        text: "مبلغ وارد شده از مبلغ کل تراکنش بیشتر است"
    },
    {
        status: "-35",
        text: "تعداد افراد دریافت کننده تسهیم بیش از حد مجاز است"
    },
    {
        status: "-36",
        text: "حداقل مبلغ جهت تسهیم باید 10000 ریال باشد"
    },
    {
        status: "-37",
        text: "یک یا چند شماره شبای وارد شده برای تسهیم از سمت بانک غیر فعال است"
    },
    {
        status: "-38",
        text: "عدم تعریف صحیح شبا، لطفاً دقایقی دیگر تلاش کنید"
    },
    {
        status: "-39",
        text: "خطایی رخ داده است"
    },
    {
        status: "-40",
        text: "پارامترهای اضافی نامعتبر"
    },
    {
        status: "-50",
        text: "مبلغ پرداخت شده با مقدار مبلغ ارسالی در متد وریفای متفاوت است"
    },
    {
        status: "-51",
        text: "پرداخت ناموفق"
    },
    {
        status: "-52",
        text: "خطای غیر منتظره‌ای رخ داده است"
    },
    {
        status: "-53",
        text: "پرداخت متعلق به این مرچنت کد نیست"
    },
    {
        status: "-54",
        text: "اتوریتی نامعتبر است"
    },
    {
        status: "101",
        text: "تراکنش وریفای شده است"
    }
];

const PaymentStatus = ({ rowData }) => {
    return (
        <span className={`break-all ${rowData.status ? "" : "text-red-400"}`}>
            {statusArray.find(item => item.status == rowData.status)?.text || "ندارد"}
        </span>
    );
}

export default PaymentStatus;
